import { Link } from 'react-router-dom';
import PublicNav from '../components/PublicNav.jsx';
import PublicFooter from '../components/PublicFooter.jsx';
import PageMeta from '../components/PageMeta.jsx';
import { useTranslation } from '../i18n/I18nContext.jsx';
import { useLocalizedPath } from '../hooks/useLocalizedPath.js';

function Section({ title, children }) {
  return (
    <div className="legal-section">
      <h2 className="legal-section-title">{title}</h2>
      {children}
    </div>
  );
}

export default function TermsPage() {
  const { t } = useTranslation();
  const lp = useLocalizedPath();

  return (
    <>
      <PageMeta
        title={t('terms.meta.title')}
        description={t('terms.meta.description')}
        path="/terms"
      />

      <div className="pub-page">
        <PublicNav />

        <main id="main-content" className="legal-page">
          <div className="legal-header">
            <h1 className="legal-title">{t('terms.header.title')}</h1>
            <p className="legal-date">{t('terms.header.lastUpdated')}</p>
            <p className="legal-intro">{t('terms.header.intro')}</p>
          </div>

          <div className="legal-body">
            <Section title={t('terms.s1.title')}>
              <p>
                {t('terms.s1.bodyPre')} <strong>{t('terms.s1.bodyStrong')}</strong> {t('terms.s1.bodyPost')}
              </p>
            </Section>

            <Section title={t('terms.s2.title')}>
              <p>{t('terms.s2.body')}</p>
            </Section>

            <Section title={t('terms.s3.title')}>
              <ul>
                <li>{t('terms.s3.item1')}</li>
                <li>
                  {t('terms.s3.item2pre')}{' '}
                  <a href="mailto:info@claw-dius.com">info@claw-dius.com</a>
                  {' '}{t('terms.s3.item2post')}
                </li>
                <li>{t('terms.s3.item3')}</li>
              </ul>
            </Section>

            <Section title={t('terms.s4.title')}>
              <ul>
                <li>{t('terms.s4.item1')}</li>
                <li>{t('terms.s4.item2')}</li>
                <li>{t('terms.s4.item3')}</li>
                <li>{t('terms.s4.item4')}</li>
                <li>{t('terms.s4.item5')}</li>
              </ul>
            </Section>

            <Section title={t('terms.s5.title')}>
              <p>{t('terms.s5.intro')}</p>
              <ul>
                <li>{t('terms.s5.item1')}</li>
                <li>{t('terms.s5.item2')}</li>
                <li>{t('terms.s5.item3')}</li>
                <li>{t('terms.s5.item4')}</li>
                <li>{t('terms.s5.item5')}</li>
                <li>{t('terms.s5.item6')}</li>
              </ul>
              <p>{t('terms.s5.outro')}</p>
            </Section>

            <Section title={t('terms.s6.title')}>
              <p>{t('terms.s6.body')}</p>
            </Section>

            <Section title={t('terms.s7.title')}>
              <p>{t('terms.s7.bodyPre')}</p>
              <ul>
                <li>{t('terms.s7.item1')}</li>
                <li>{t('terms.s7.item2')}</li>
                <li>{t('terms.s7.item3')}</li>
              </ul>
              <p>{t('terms.s7.bodyPost')}</p>
            </Section>

            <Section title={t('terms.s8.title')}>
              <p>{t('terms.s8.bodyPre')}</p>
              <ul>
                <li>{t('terms.s8.item1')}</li>
                <li>{t('terms.s8.item2')}</li>
                <li>{t('terms.s8.item3')}</li>
                <li>{t('terms.s8.item4')}</li>
              </ul>
              <p>{t('terms.s8.bodyPost')}</p>
            </Section>

            <Section title={t('terms.s9.title')}>
              <p>{t('terms.s9.body')}</p>
            </Section>

            <Section title={t('terms.s10.title')}>
              <p>{t('terms.s10.body')}</p>
            </Section>

            <Section title={t('terms.s11.title')}>
              <p>{t('terms.s11.body1')}</p>
              <p>
                {t('terms.s11.body2pre')}{' '}
                <a href="mailto:info@claw-dius.com">info@claw-dius.com</a>
                {' '}{t('terms.s11.body2mid')}{' '}
                <Link to={lp('/contact')}>{t('terms.s11.contactFormLink')}</Link>
                {t('terms.s11.body2post')}
              </p>
            </Section>

            <Section title={t('terms.s12.title')}>
              <p>{t('terms.s12.body')}</p>
            </Section>

            <Section title={t('terms.s13.title')}>
              <p>{t('terms.s13.body')}</p>
            </Section>

            <Section title={t('terms.s14.title')}>
              <p>{t('terms.s14.intro')}</p>
              <ul>
                <li>{t('terms.s14.emailLabel')}: <a href="mailto:info@claw-dius.com">info@claw-dius.com</a></li>
                <li>{t('terms.s14.contactFormPre')} <Link to={lp('/contact')}>{t('terms.s14.contactFormLink')}</Link></li>
              </ul>
            </Section>
          </div>

          <nav className="legal-nav" aria-label={t('terms.nav.ariaLabel')}>
            <Link to={lp('/')}>{t('terms.nav.backHome')}</Link>
            <Link to={lp('/privacy')}>{t('terms.nav.privacy')}</Link>
            <Link to={lp('/contact')}>{t('terms.nav.contact')}</Link>
          </nav>
        </main>

        <PublicFooter />
      </div>
    </>
  );
}
